
<div>
  <div v-if="boardItem.boardItemStatus === statusType.Information">
    <!-- Valid From -->
    <div>
      <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
        <div>From</div>
      </div>
      <board-item-date-picker v-model="fromDate"></board-item-date-picker>
    </div>

    <!-- Valid To -->
    <div>
      <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
        <div>To</div>
      </div>

      <board-item-date-picker v-model="toDate"></board-item-date-picker>
    </div>
  </div>

  <!-- Due and Planned date -->
  <div v-else>
    <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-between align-items-center">
        <div
          class="cursor-pointer"
          @click="selectedDate = !disabled ? 'due' : 'due'"
          :class="{ 'font-weight-bold': dueSelected && displayPlannedDate }"
        >
          Due
        </div>
        <div class="ml-1 mr-1" v-if="displayPlannedDate">|</div>
        <div
          class="cursor-pointer"
          v-if="displayPlannedDate"
          @click="selectedDate = !disabled ? 'planned' : 'due'"
          :class="{ 'font-weight-bold': plannedSelected }"
        >
          Planned
        </div>
      </div>
      <div v-if="dueSelected"><DueBadge :item="boardItem" :only-overdue="true"></DueBadge></div>
    </div>

    <div v-if="dueSelected">
      <board-item-date-picker v-model="dueDate" :disabled="disabled" />
    </div>
    <div v-if="plannedSelected">
      <board-item-date-picker v-model="plannedDate" :disabled="disabled" />
    </div>
  </div>
</div>
